import { toAmericanDate } from '../../../helpers';
import {
  CORE, gatewayShortJson, gateway,
  RELATORIOS,
} from '../../api';

export function findUsuariosPermitidos() {
  return gatewayShortJson.get(`${CORE}/controle-bordero/usuarios`);
}
export function findResumoMensal(dataInicio, dataFinal) {
  const params = {
    dataInicio,
    dataFinal,
  };
  return gateway.get(`${CORE}/controle-bordero/resumo-mensal`, { params });
}
export function findMapaBordero(dataBase, idUsuario) {
  const params = {
    dataBase,
    idUsuario,
  };
  return gateway.get(`${CORE}/controle-bordero/mapa-bordero`, { params });
}
export function findControleDeEntrada(dataInicio, dataFinal, idUsuario) {
  const params = {
    dataInicio,
    dataFinal,
    idUsuario,
  };
  return gateway.get(`${CORE}/controle-bordero/controle-de-entrada`, { params });
}
export function findControleDeEntradaAgrupado(dataInicio, dataFinal, idUsuario) {
  const params = {
    dataInicio,
    dataFinal,
    idUsuario,
  };
  return gateway.get(`${CORE}/controle-bordero/controle-de-entrada/agrupado`, { params });
}
export function imprimirMapaBordero(dataBase, usuarioSelecionado, isQtdProcessos, clienteAtivo) {
  const payload = {
    dataBase: toAmericanDate(dataBase),
    usuarioSelecionado,
    isQtdProcessos,
    clienteAtivo,
  };
  return gateway.post(`${RELATORIOS}/controle-bordero/mapa-bordero/imprimir`, payload);
}

export function imprimirControleEntrada(dataInicial, dataFinal, usuarioSelecionado, isTotalizarPorCliente) {
  const payload = {
    dataInicial: toAmericanDate(dataInicial),
    dataFinal: toAmericanDate(dataFinal),
    usuarioSelecionado,
    isTotalizarPorCliente,
  };
  return gateway.post(`${RELATORIOS}/controle-bordero/controle-entrada/imprimir`, payload);
}

export function imprimirResumoMensal(dataInicial, dataFinal) {
  const payload = {
    dataInicial: toAmericanDate(dataInicial),
    dataFinal: toAmericanDate(dataFinal),
  };
  return gateway.post(`${RELATORIOS}/controle-bordero/resumo-mensal/imprimir`, payload);
}
